import { ApolloClient, InMemoryCache, NormalizedCacheObject } from '@apollo/client';

const isSSR = typeof window === 'undefined';
let apolloClient = null;

const createApolloClient = () =>
  new ApolloClient({
    uri: process.env.CMS_URI,
    ssrMode: isSSR,
    cache: new InMemoryCache(),
  });

export function initializeApollo(initialState = null): ApolloClient<NormalizedCacheObject> {
  const _apolloClient = apolloClient ?? createApolloClient();

  // If your page has Next.js data fetching methods that use Apollo Client,
  // the initial state gets hydrated here
  if (initialState) {
    // Get existing cache, loaded during client side data fetching
    const existingCache = _apolloClient.extract();

    // Restore the cache using the data passed from
    // getStaticProps/getServerSideProps combined with the existing cached data
    _apolloClient.cache.restore({ ...existingCache, ...initialState });
  }

  // For SSG and SSR always create a new Apollo Client
  if (isSSR) return _apolloClient;

  // Create the Apollo Client once in the client
  if (!apolloClient) apolloClient = _apolloClient;
  return _apolloClient;
}
